import React from 'react';
import { BoxBody } from "./InboxPageBody";

const Body = (props : any) => {

  return (
    <BoxBody />
  );
};

export default Body;